import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import PieGraph from "../../../general/PieGraph";
import Functions from "../../../../services/Functions";
import styles from "./EducationL1.module.css";

function EducationL1({ distrito }) {
  const [nivelEscolaridade, setNivelEscolaridade] = useState(null);
  const [matriculaEscola, setMatriculaEscola] = useState(null);
  const [qualidadeEscolasRurais, setQualidadeEscolasRurais] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [nivelEscolaridade, matriculaEscola, qualidadeEscolasRurais] =
          await Promise.all([
            Api.getNivelEscolaridade(distrito),
            Api.getMatriculaEscola(distrito),
            Api.getQualidadeEscolasRurais(distrito),
          ]);
        setNivelEscolaridade(
          Functions.buildPieGraphParams2(nivelEscolaridade)
        );
        setMatriculaEscola(Functions.buildPieGraphParams2(matriculaEscola));
        setQualidadeEscolasRurais(
          Functions.buildPieGraphParams2(qualidadeEscolasRurais)
        );
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [distrito]);

  const mockupFunction = (value) => {
    value = value + 1;
  };

  return (
    <div className={styles.educationL1}>
      <div className={styles.smallPiegraph}>
        {nivelEscolaridade && (
          <PieGraph
            data={nivelEscolaridade}
            text="NÍVEL ESCOLARIDADE"
            onLegendClick={mockupFunction}
            currentValue={null}
            oldValue={null}
            onOldValue={mockupFunction}
            onImageReady={mockupFunction}
          />
        )}
      </div>
      <div className={styles.smallPiegraph}>
        {matriculaEscola && (
          <PieGraph
            data={matriculaEscola}
            text="MATRICULADO ESCOLA"
            onLegendClick={mockupFunction}
            currentValue={null}
            oldValue={null}
            onOldValue={mockupFunction}
            onImageReady={mockupFunction}
          />
        )}
      </div>
      <div className={styles.smallPiegraph}>
        {qualidadeEscolasRurais && (
          <PieGraph
            data={qualidadeEscolasRurais}
            text="QUALIDADE DAS ESCOLAS RURAIS"
            onLegendClick={mockupFunction}
            currentValue={null}
            oldValue={null}
            onOldValue={mockupFunction}
            onImageReady={mockupFunction}
          />
        )}
      </div>
    </div>
  );
}

export default EducationL1;
